import { assertNever } from '@tableau/data-structures';
import { BlankBaseIcon } from '@tableau/icons/BlankBaseIcon';
import { BooleanBaseIcon } from '@tableau/icons/BooleanBaseIcon';
import { CalendarBaseIcon } from '@tableau/icons/CalendarBaseIcon';
import { CalendarClockIcon } from '@tableau/icons/CalendarClockIcon';
import { CurrencyBaseIcon } from '@tableau/icons/CurrencyBaseIcon';
import { NumberBaseIcon } from '@tableau/icons/NumberBaseIcon';
import { TextStringIcon } from '@tableau/icons/TextStringIcon';
import React from 'react';
import { RemoteType } from '../../../../../../gen-src/queries';


export function RemoteTypeIcon(props: { remoteType: RemoteType }): JSX.Element {
  // References for mapping https://opengrok/source/xref/teams_near/modules/connectors/tabmixins/main/db/OLEDBProtocol.cpp#2389
  // https://opengrok/source/xref/teams_near/modules/platform/tabdoc/main/interface/DataTypeIcons.cpp
  // https://opengrok/source/xref/teams_near/modules/platform/tabcore/public/core/TableauDBType

  switch (props.remoteType) {
    case RemoteType.BOOL:
    case RemoteType.WDC_BOOL:
      return <BooleanBaseIcon size={14} color={'#367E9C'} alt="Boolean Icon" />;
    case RemoteType.CY:
      return <CurrencyBaseIcon size={14} color={'#367E9C'} alt="Currency Base Icon" />;
    case RemoteType.DATE:
    case RemoteType.DBDATE:
    case RemoteType.WDC_DATE:
      return <CalendarBaseIcon size={14} color={'#367E9C'} alt="Calendar Base Icon" />;
    case RemoteType.DBTIME:
    case RemoteType.DBTIMESTAMP:
    case RemoteType.FILETIME:
    case RemoteType.WDC_DATETIME:
      return <CalendarClockIcon size={14} color={'#367E9C'} alt="Calendar Clock Icon" />;
    case RemoteType.I1:
    case RemoteType.I2:
    case RemoteType.I4:
    case RemoteType.I8:
    case RemoteType.NUMERIC:
    case RemoteType.NULL:
    case RemoteType.R4:
    case RemoteType.R8:
    case RemoteType.UDT:
    case RemoteType.UI1:
    case RemoteType.UI2:
    case RemoteType.UI4:
    case RemoteType.UI8:
    case RemoteType.DECIMAL:
    case RemoteType.VARNUMERIC:
    case RemoteType.WDC_FLOAT:
    case RemoteType.WDC_INT:
      return <NumberBaseIcon size={14} color={'#367E9C'} alt="Number Base Icon" />
    case RemoteType.ARRAY:
    case RemoteType.BSTR:
    case RemoteType.BYREF:
    case RemoteType.BYTES:
    case RemoteType.GUID:
    case RemoteType.STR:
    case RemoteType.WSTR:
    case RemoteType.VARIANT:
    case RemoteType.VECTOR:
    case RemoteType.WDC_STRING:
      return <TextStringIcon size={14} color={'#367E9C'} alt="Text String Icon" />;
    case RemoteType.EMPTY:
    case RemoteType.ERROR:
    case RemoteType.HCHAPTER:
    case RemoteType.IDISPATCH:
    case RemoteType.IUNKNOWN:
    case RemoteType.PROPVARIANT:
    case RemoteType.RESERVED:
    case RemoteType.WDC_GEOMETRY:
      return <BlankBaseIcon size={14} alt="Blank Base Icon" />;
    default:
      assertNever(props.remoteType);
      return <BlankBaseIcon size={14} alt="Blank Base Icon" />;
  }
}